﻿import { Page } from '@shopify/polaris'
import { ChatWidget } from '@/components/chat/ChatWidget'

export function ChatPage() {
  return (
    <Page fullWidth title="AI Chat" subtitle="Ask GrowthPilot AI anything about your store">
      <ChatWidget />
    </Page>
  )
}
